import { getContentPropertyValue } from 'content-management-data-lib';
import { CRM_DYNAMIC_PAGE_REGEX, HUBDB_DATA_SOURCE_TYPE, HUBDB_REGEX } from '../constants/dynamicPage';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
export const getContentDynamicPageHubDbTableId = contentCrmObject => {
  const dynamicPageSourceType = getContentPropertyValue(contentCrmObject, PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_TYPE);
  const dynamicPageSourceId = getContentPropertyValue(contentCrmObject, PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_ID);
  return dynamicPageSourceType === HUBDB_DATA_SOURCE_TYPE ? dynamicPageSourceId : undefined;
};
export const resolveAnalyticsPageId = (analyticsId, pathname) => {
  if (HUBDB_REGEX.test(pathname)) {
    var _HUBDB_REGEX$exec;
    return (_HUBDB_REGEX$exec = HUBDB_REGEX.exec(pathname)) === null || _HUBDB_REGEX$exec === void 0 ? void 0 : _HUBDB_REGEX$exec[0];
  }
  if (CRM_DYNAMIC_PAGE_REGEX.test(pathname)) {
    var _CRM_DYNAMIC_PAGE_REG;
    return (_CRM_DYNAMIC_PAGE_REG = CRM_DYNAMIC_PAGE_REGEX.exec(pathname)) === null || _CRM_DYNAMIC_PAGE_REG === void 0 ? void 0 : _CRM_DYNAMIC_PAGE_REG[0];
  }
  return analyticsId;
};